import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import {
  DRAWER_PARAM_KEYS,
  getCleanDrawerParams,
  queryKeys,
  queryValues,
} from '~/routes/query-params';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

interface OpenDrawerParams {
  id: string;
  trackingProperties: Record<string, unknown> & {
    source: PosthogTrackingSource;
  };
  relation?: string;
}

export const useInsightDrawer = () => {
  const { setQueryParams, deleteQueryParam } = useQueryParams();
  const { trackInsightsDrawerOpen } = usePosthogEvents();

  const openDrawer = ({
    id,
    trackingProperties,
    relation,
  }: OpenDrawerParams) => {
    const { source, ...rest } = trackingProperties;
    trackInsightsDrawerOpen(source, 'simple', rest);
    setQueryParams({
      ...getCleanDrawerParams(),
      [queryKeys.activeInsight]: id,
      [queryKeys.activeDrawer]: queryValues.insightsDrawer,
      [queryKeys.source]: source,
      [queryKeys.insightRelation]: relation ?? undefined,
    });
  };

  const closeDrawer = () => {
    deleteQueryParam([...DRAWER_PARAM_KEYS, queryKeys.drawerExpanded], {
      replace: true,
    });
  };

  return {
    openDrawer,
    closeDrawer,
  };
};
